import type { TransitionVariant } from './constants'
import type { TransitionPhase, TransitionTiming } from './types'

/**
 * Builds the transition string that maps to the CSS class for a transition.
 *
 * @param variant The transition variant.
 * @param phase The transition phase.
 * @returns A hypenated string.
 */
export function transitionClass(
  variant: TransitionVariant,
  phase: TransitionPhase,
) {
  return `${variant}-${phase}`
}

/**
 * Gets the transition classes basd on the variant and timing.
 *
 * @param variant The transition variant.
 * @param timing The transition timing.
 * @returns An object with properties that Vue's Transition can handle.
 */
export function getTransitionClasses(
  variant: TransitionVariant,
  timing: TransitionTiming,
) {
  const timingClass = `timing-${timing}`

  return {
    enterActiveClass: `${transitionClass(variant, 'enter-active')} ${timingClass}`,
    enterFromClass: transitionClass(variant, 'enter-from'),
    leaveActiveClass: `${transitionClass(variant, 'leave-active')} ${timingClass}`,
    leaveToClass: transitionClass(variant, 'leave-to'),
  }
}
